import axios from 'axios'
import AuthService from './AuthService'

const http = axios.create({
  baseURL: '/ssp',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-NoAuthChallenge': '1' // ssp specific header
  }
})

http.interceptors.request.use((config) => {
  if (config.roles && !(config.roles.some((r) => AuthService.hasRole(r)))) {
    const newError = new Error()
    newError.response = { status: 403, data: { message: `No access. Requires: ${config.roles}` } }
    throw newError
  }
  return config
}, ((error) => Promise.reject(error)))

// response interceptor
http.interceptors.response.use((response) => response, (error) => {
  if (error.response.status === 401 && !window.location.href.includes('login')) {
    document.location.href = '/'
  }
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/service/http.js